"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShreddingMode = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const form_text_field_1 = require("../../../composite/form/fields/form-text-field");
const form_panel_1 = require("../../../composite/form/fields/form-panel");
const form_number_field_1 = require("../../../composite/form/fields/form-number-field");
function ShreddingMode() {
    return (react_1.default.createElement(form_panel_1.FormPanel, { label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ESS_SHREDING_MODE_PANEL_TITLE", defaultMessage: "Skarta\u010Dn\u00ED re\u017Eim" }) },
        react_1.default.createElement(form_text_field_1.FormTextField, { name: "shreddingMode.symbol", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ESS_SHREDING_MODE_FIELD_LABEL_SYMBOL", defaultMessage: "Skarta\u010Dn\u00ED znak" }) }),
        react_1.default.createElement(form_number_field_1.FormNumberField, { name: "shreddingMode.period", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "ESS_SHREDING_MODE_FIELD_LABEL_PERIOD", defaultMessage: "Skarta\u010Dn\u00ED lh\u016Fta" }) })));
}
exports.ShreddingMode = ShreddingMode;
//# sourceMappingURL=shredding-mode.js.map